const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
/*Variant Selection*/
class VariantSelectors extends HTMLElement {
  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  connectedCallback() {
    const select = this.querySelector("select");
    if (select) {
      select.addEventListener("change", this.onChange);
    }
  }

  onChange(e) {
    const selectedValue = e.target.value;
    if (!selectedValue) return;
    let productForm =
      e.target.closest(".product-card-item") ||
      e.target.closest(".product-single") ||
      e.target.closest(".cart-upsells__product--item");

    const options = e.target.querySelectorAll("option");
    options.forEach((option) => {
      if (option.value === selectedValue) {
        option.setAttribute("selected", "selected");

        const variantIdInput = productForm?.querySelector('input[name="id"]');
        const addToCartButton = productForm?.querySelector(
          "product-form-new button"
        );
        const buttonLabel = productForm?.querySelector("button span");

        if (option.classList.contains("unavailable")) {
          addToCartButton && (addToCartButton.disabled = true);
          buttonLabel && (buttonLabel.innerText = "Sold Out");
        } else {
          addToCartButton && (addToCartButton.disabled = false);
          buttonLabel && (buttonLabel.innerText = "Add To Cart");
        }

        if (variantIdInput) {
          variantIdInput.value = option.dataset.variantId;
          option.dispatchEvent(new Event("change", { bubbles: true }));
        }
      } else {
        option.removeAttribute("selected");
      }
    });
  }
}
customElements.define("variant-selectors", VariantSelectors);
/*End Variant Selection*/

class CartMiniTrigger extends HTMLElement {
  constructor() {
    super();
    this.cartMini = document.querySelector("cart-mini");
    this.button = this.querySelector("button");
    this.addEventListener("click", this.onTriggerClick);
  }

  onTriggerClick(event) {
    const isOpen = this.hasAttribute("open");
    isOpen ? this.closeCartMini() : this.openCartMini();
  }

  resetState() {
    this.removeAttribute("open");
    this.button.classList.remove("is--active");
    document.body.classList.remove("overflow-hidden");
  }

  openCartMini() {
    this.setAttribute("open", true);
    this.button.classList.add("is--active");
    this.closest("html").classList.add("overflow-hidden");
    this.cartMini.open();
    //Trigger upsell fetch here
    loadUpsellFromLastProduct();
  }

  closeCartMini() {
    this.resetState();
    document.querySelector("html").classList.remove("overflow-hidden");
    this.cartMini.close();
  }
}
customElements.define("cart-mini-trigger", CartMiniTrigger);

function loadUpsellFromLastProduct() {
  const upsellContainer = document.querySelector("#cart-upsell-container");
  let productIdString = document.querySelector(".cart-mini-items tr").dataset
    .productId;
  let productId = Number(productIdString);
  // Save last added product ID to localStorage
  localStorage.setItem("lastAddedProductId", productId);
  const lastProductId = Number(localStorage.getItem("lastAddedProductId"));

  if (upsellContainer && lastProductId) {
    try {
      const config = JSON.parse(upsellContainer.dataset.cartUpsellOptions);
      const url = `${config.baseurl}?product_id=${lastProductId}&section_id=${config.section_id}&limit=${config.limit}&intent=complementary`;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const recommendedSection = doc.querySelector(`#${config.section_id}`);

          if (recommendedSection) {
            const target = document.querySelector(`#${config.section_id}`);
            if (target) target.innerHTML = recommendedSection.innerHTML;
          }
        })
        .catch((err) => {
          console.warn("Product recommendations failed to load:", err);
        });
    } catch (error) {
      console.error("Upsell config error:", error);
    }
  }
}
